import { Box, Typography } from "@mui/material"
import { DinamicForm } from "../../../../../../../../components/dinamicForm"
import { SearchAndAddUserProps } from "./types"
import { FooterSimple } from "../../../../../../../../components/buttons/footer"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { CustomPaper } from "../../../../../../../../components/CustomPaper"

export const SearchAndAddUser = ({ form, cancel, confirm, }: SearchAndAddUserProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    return (
        <CustomPaper sx={styles.paperRoot}>
            <Box sx={styles.container}>
                <Box sx={styles.filter}>
                    <Typography variant="subtitle_grey" fontWeight='bold'>{t('general.searchUsers')}</Typography>

                    <DinamicForm {...form} />
                </Box>

                <FooterSimple
                    cancel={{
                        children: <Typography>{t('general.cleanFilters')}</Typography>,
                        ...cancel
                    }}
                    confirm={{
                        children: <Typography>{t('general.search')}</Typography>,
                        ...confirm
                    }}
                />
            </Box>
        </CustomPaper>
    )
}